import Vue from 'vue';
import Vuelidate from 'vuelidate';
import {
    minValue,
    numeric,
    required,
    requiredIf
} from 'vuelidate/lib/validators';
import datePicker from '../../../components/forms/component.date-picker.vue';
import ageSwitch from '../../../components/forms/component.age-birthdate-input-switch.vue';
import { MainVueOpts } from '../../../main-vue';
import MultiSelect from 'vue-multiselect';
import TravelexPlanIds from '../../../helper-functions/companies/travelex-planids';
import {
    convertDateByLang,
    createDateByLangApplications,
    dateNotInFuture,
    isAfterField,
    monthDate,
    noAlphabets,
    numbersWithDashSlash,
    onlyAlphaNumeric
} from '../../../helper-functions/helper-functions';
import {
    changeInSessionStorage,
    createUpdateApplicationService,
    goToFirstError,
    hideValidationsWhileTyping
} from '../../../helper-functions/services';
import Step1Mixin from '../mixins/Step1Mixin';
import { travelexConfig } from '../../../helper-functions/app-configs';

Vue.use(Vuelidate);
Vue.component('multiselect', MultiSelect);

const repurchaseOptions = {
    SAME_PLAN_DIFF_PERSON: '1',
    DIFF_PLAN_DIFF_PERSON: '3'
}
const travelexPlanIds = new TravelexPlanIds();

export default {
    mixins:[MainVueOpts, Step1Mixin],
    components:{
        'date-picker': datePicker,
        'age-switch': ageSwitch
    },
    props:['form-data'],
    data: function(){
        return {
            travelerLimit: 10,
            numTravelersSelected: ibJS.application && ibJS.application.travelerInfos ? ibJS.application.travelerInfos.length || '' : "",
            formSending:false,
            previousLoading: false,
            showMobileError:false,
            showPrimaryValidation:false,
            disableApplication: false,
            showPrimaryValidationForTripCost: false,
            showSecondaryValidationForTripCost: false,
            showSecondaryValidationForAge: false,
            submitted: false,
            initialTripDepositDate: ibJS.application ? ibJS.application.initialTripDepositDate : null,
            isBasicPlan: travelexConfig.isBasicPlan(),
            isSelectPlan: travelexConfig.isSelectPlan(),
            triggerAllTravelerValidation: false,
            residenceState: ibJS.application ? ibJS.application.mailingAddress ? ibJS.application.mailingAddress.state : '' : '',
            isTXFlightPlan: travelexConfig.isTXFlightPlan(),
            isTXFlightInsurePlus: travelexConfig.isFlightInsurePlus(),
            isTXFlightInsure: travelexConfig.isFlightInsure(),
            UserLoggedInMyAcoount: ibJS.UserLoggedInMyAcoount,
            multiselectFocus: false,
            form:{
                startDate: this.formData.startDate || '',
                endDate: this.formData.endDate || '',
                travelerInfos: this.formData.travelerInfos,
                destinationCountries: null,
                planId: ibJS.planId
            },
            countries: ibJS.countries,
            popularCountries: ibJS.popularCountries,
            currentLang:window.globalLanguage.lang,
            travelexPlanId: new TravelexPlanIds()
            // isTravelexFlight: true
        }
    },
    validations: function(){
        const self = this;
        const validations = {
            form: {
                startDate: {
                    monthDate,
                    numbersWithDashSlash,
                    noAlphabets,
                    required
                },
                endDate: {
                    required,
                    monthDate,
                    numbersWithDashSlash,
                    noAlphabets,
                    isAfterStartDate: isAfterField('startDate', this.submitted)
                },
                travelerInfos: {
                    $each: {
                        age: this.isTXFlightPlan ? {minValue: minValue(0)} 
                            : {required, minValue: minValue(0)},
                        tripCost: this.isTXFlightPlan ? {} : {
                            required,
                            numeric,
                            minValue: minValue(1)
                        }
                    }
                },
                destinationCountries: {
                    required: requiredIf(()=>(self.isBasicPlan || self.isSelectPlan || self.form.planId == travelexPlanIds.Travel_Basic_Parent || self.form.planId == travelexPlanIds.Travel_Select_Parent))
                },
            },
            // initialTripDepositDate: {
            //     required : !this.isTravelexFlight,
            //     onlyAlphaNumeric :!this.isTravelexFlight,
            //     monthDate: !this.isTravelexFlight,
            //     dateNotInFuture: !this.isTravelexFlight
            // },
            initialTripDepositDate: {
                required,
                onlyAlphaNumeric,
                monthDate,
                dateNotInFuture: (val) => dateNotInFuture(val, ibJS.systemTimeCST)
            },
            residenceState: {
                required
            },
            numTravelersSelected: this.isTXFlightPlan ? { required } : {},
        };

        let isTouched = false;

         /* No need to display traveler error msg only when the number of travelerslarger than 3. will delete once we do not change back anymore */
        // if(this.form.travelerInfos.length >= 3) {
        //     for(var i = 1 ; i < this.form.travelerInfos.length; i++) {
        //         if(this.form.travelerInfos.length > 3) {
        //             isTouched = true;
        //             break;
        //         } else if((this.form.travelerInfos[i].age != null && this.form.travelerInfos[i].age.toString().trim() !== "")
        //             || (this.form.travelerInfos[i].tripCost != null && this.form.travelerInfos[i].tripCost.toString().trim() !== "")) {
        //             if(i===1 && (this.form.travelerInfos[i].age != null && this.form.travelerInfos[i].age.toString().trim() !== "")
        //                 && (this.form.travelerInfos[i].tripCost != null && this.form.travelerInfos[i].tripCost.toString().trim() !== "")) {

        //             } else {
        //                 isTouched = true;
        //                 break;
        //             }
        //         }
        //     }
        // }
        // if(isTouched) {
        //     validations.form.travelerInfos.$each.age.required = required;
        //     validations.form.travelerInfos.$each.tripCost.required = required;
        // } else {
        //     delete validations.form.travelerInfos.$each.age.required;
        //     delete validations.form.travelerInfos.$each.tripCost.required;
        // }

        return validations;
    },
    created: function(){
        if(ibJS.application && ibJS.application.mailingAddress) {
            if(ibJS.application.mailingAddress.state !== sessionStorage.getItem('validatedState')) {
                changeInSessionStorage('validatedState', '');
                changeInSessionStorage('addressValidated', false);
            }
        }

        // constructor function
        function newTraveler() {
            this.age = null;
            this.tripCost = null;
            this.quotePrice = null;
            this.travelerType = '';
        }

        var self = this;

        // for each traveler in the application.travelerInfos list, create a 
        // new traveler object and set properties
        if(self.application != null){
            if((self.isBasicPlan || self.isSelectPlan || self.form.planId == travelexPlanIds.Travel_Basic_Parent || self.form.planId == travelexPlanIds.Travel_Select_Parent) && self.application.destinations){
                    const destinationCountries = this.countriesList.filter(item => item.country === this.application.destinations);
                    if (destinationCountries && destinationCountries.length) self.form.destinationCountries = destinationCountries[0];
            }
            if(self.application.travelerInfos.length) {
                self.form.travelerInfos =[];
            } 
            for(var i = 0; i < self.application.travelerInfos.length; i++){
                const newTraveler = {
                    age: self.application.travelerInfos[i].age,
                    tripCost: self.application.travelerInfos[i].tripCost > 0 ? self.application.travelerInfos[i].tripCost : null,
                    quotePrice: null,
                    travelerType: self.application.travelerInfos[i].travelerType
                };

                self.form.travelerInfos.push(newTraveler); // add new traveler object to form.travelerInfos list
            }

            /* No need to add empty optional traveler anymore,  will delete once we do not change back anymore */
            // if(self.form.travelerInfos && Array.isArray(self.form.travelerInfos) && self.form.travelerInfos.length === 1){
            //     // adds 2 blank new travelers to list if there was only 1
            //     self.form.travelerInfos.push(new newTraveler(),new newTraveler());
            // } else if (self.form.travelerInfos && Array.isArray(self.form.travelerInfos) && self.form.travelerInfos.length === 2){
            //     // adds 1 blank new traveler to list if there were only 2
            //     self.form.travelerInfos.push(new newTraveler());
            // }

            self.travelersOpened = true;
        } else {
            // For trip plan, only keep one blank traveler
            if(self.form.travelerInfos && self.form.travelerInfos.length > 1) {
                self.form.travelerInfos = self.form.travelerInfos.slice(0,1);
            }
        } 

        if (ibJS.option === repurchaseOptions.SAME_PLAN_DIFF_PERSON || ibJS.option === repurchaseOptions.DIFF_PLAN_DIFF_PERSON) { // for purchase again different persons
            self.form.travelerInfos = self.form.travelerInfos.slice(0,1);
        }

        $(document).ready(function () {
            $('.o-Form').on('click', function () {
                self.showTravelers = false;
            });

            $('.js-Stop-propagation').on('click', function (e) {
                e.stopPropagation();
            });
        });
    },
    watch:{
        'form.startDate' : function(){
            this.showMobileError = false;
        },
        'form.endDate' : function(){
            this.showMobileError = false;
        },
        initialTripDepositDate : function(){
            this.showMobileError = false;
        },
        'form.travelerInfos' : function(){
            Vue.nextTick(()=>{
                this.addInputFocusOutline();
            });
        },
        'residenceState' : function(){
            changeInSessionStorage('addressValidated', false);
            changeInSessionStorage('validatedState', '');
        }
        // numTravelersSelected: function() {
        //     console.log('num of travelers selected: ', this.numTravelersSelected);
        // }
    },
    mounted: function(){
        this.addInputFocusOutline();
        convertDateByLang(this.form,window.globalLanguage.lang);
        hideValidationsWhileTyping(['initialTripDepositDate']);
    },
    computed: {
        countriesList: function(){
            let i;
            let newCountry;
            const countryList = [];
            if (this.popularCountries.length) {
                for (i = 0; i < this.popularCountries.length; i++) {
                    let countryText = this.popularCountries[i].country || null;
                    let countryValue = this.popularCountries[i].value || null;

                    newCountry = {
                        name: countryText,
                        country: countryValue
                    };

                    if (countryValue === 'USA'){
                        countryList.unshift(newCountry);
                    } else{
                        countryList.push(newCountry);
                    }
                }
            }

            if (this.countries.length) {
                i = 0;
                const countryLen = this.countries.length;
                for (; i < countryLen; i++) {
                    let countryText = this.countries[i].country || null;
                    let countryValue = this.countries[i].value || null;

                    newCountry = {
                        name: countryText,
                        country: countryValue
                    };

                    countryList.push(newCountry);
                }
            }
            return countryList;
        },
        hasDestUS() {
            return this.form.destinationCountries?.country === 'USA';
        },
        disableContinue() {
            return this.showMobileError || this.$v.$error;
        }
        /* No need to display traveler error msg only when the number of travelerslarger than 3. will delete once we do not change back anymore */
        // travelerTripCostShowValidation: function () {
        //     let isVisible = false;

        //     if(this.form.travelerInfos.length <= 3) {
        //         isVisible = !(!this.form.travelerInfos[2].tripCost && !this.form.travelerInfos[2].age);
        //     } else {
        //         isVisible = true;
        //     }

        //     return isVisible;
        // }
    },
    methods: {
        createQuote: function (e) {      
            // add array of travelers with no information whose length is selected in
            // numTravelersSelected dropdown, so this can be used on Step3
            if(this.isTXFlightPlan) {
                if(this.application && this.application.travelerInfos.length === this.numTravelersSelected) {
                    this.form.travelerInfos = this.application.travelerInfos;
                } else {
                    //reset travelerInfos for TXFlight
                    this.form.travelerInfos = [];
                    for(let i = 0; i < this.numTravelersSelected; i++) {
                        this.addTraveler();
                    }
                }
            }
            e.preventDefault();

            let error = false;

            this.showPrimaryValidation = false;

            // informs vuelidate that model and children have been touched by user
            this.$v.$touch();

            if(!this.isTXFlightPlan){
                    // set error for traveler's age
                if(this.form.travelerInfos[0].age===null || this.form.travelerInfos[0].age===''){
                    error=true;
                    this.showPrimaryValidation=true;
                }

                // set error for trip cost
                if(this.form.travelerInfos.length > 0 &&
                    (this.form.travelerInfos[0].tripCost == null || this.form.travelerInfos[0].tripCost === '')) {
                    error = true;
                    this.showPrimaryValidationForTripCost = true;
                }

                // If null/blank age for traveler, remove traveler from travelerInfos array
                if (!this.$v.$invalid &&  error === false) {
                    for(var k = 1; k < this.form.travelerInfos.length; k++) {
                        if (!this.showPrimaryValidation && (this.form.travelerInfos[k].age === null || this.form.travelerInfos[k].age === '')) {
                            this.form.travelerInfos.splice(k, 1);
                            k -= 1;
                        }
                    }
                }


                for(var i = 1; i < this.form.travelerInfos.length; i++){
                    if(!this.showPrimaryValidation && (this.form.travelerInfos[i].age === null || this.form.travelerInfos[i].age === '')){
                        for(let j = i+1; j < this.form.travelerInfos.length; j++){
                            if(this.form.travelerInfos[j] && (this.form.travelerInfos[j].age !==null && this.form.travelerInfos[j].age !=='')){
                                $('#traveler_' + i + '_missingInsured_error').css('display','');
                                error = true;
                                Vue.nextTick(() => goToFirstError());
                                break;
                            }
                        }
                    }
                    else{
                        $('#traveler_' + i + '_missingInsured_error').css('display','none');
                    }

                    if((this.form.travelerInfos[i].tripCost != null && this.form.travelerInfos[i].tripCost !== '')
                        &&(this.form.travelerInfos[i].age == null || this.form.travelerInfos[i].age === '')){
                        error = true;
                        this.showSecondaryValidationForAge = true;
                    }
                    else{
                        this.showSecondaryValidationForAge = false;
                    }
                }
            }

            var quoteResultsURL='/api/' + ibJS.productName + '/quote-results/?lang=' + window.globalLanguage.lang;
            if (!this.$v.$invalid && !error) {
                var _this = this;

                if(!this.isTXFlightPlan) this.spliceTravelers();

                this.form.initialTripDepositDate = this.initialTripDepositDate;
                this.form.mailingAddress = {
                    state: this.residenceState
                };

                Vue.nextTick(() => {
                    _this.hideDateError = true;
                    let langBasedData = Object.assign({}, this.form);
                    const defaultTravelers = 1;
                    if (this.form.planId == travelexPlanIds.Travel_Basic_Parent || this.form.planId == travelexPlanIds.Travel_Select_Parent) {
                        langBasedData.destinations = this.form.destinationCountries.country;
                        // delete this.form.destinationCountries;
                        delete langBasedData.destinationCountries;
                    }
                    createDateByLangApplications(langBasedData, window.globalLanguage.lang);
                    createUpdateApplicationService.call(this, quoteResultsURL, langBasedData, 'application', defaultTravelers === 1); // if default is one traveler pass the last parameter as true
                    this.submitted = true;
                });
                this.submitted = false;
                _this.hideDateError = false;
            }else{
                Vue.nextTick(() => goToFirstError());
                this.showMobileError = true;
            }
        },
        addTraveler: function() {
            const newTraveler = {
                tripCost: null,
                age: null,
                travelerType: ''
            };
            
            if(!this.isTXFlightPlan) {
                this.triggerAllTravelerValidation = true;
            }
            this.form.travelerInfos.push(newTraveler);
        },
        resetAgeValidation: function(index){
            if(!(/^\d+$/.test(this.form.travelerInfos[index].age))){
                this.form.travelerInfos[index].age=null;
            }
            if(index === 0){
                this.showPrimaryValidation=false;
            }else if(index === 1){
                this.showSecondaryValidationForAge = false;
            }else if(index>1){
                this.showSecondaryValidationForAge = false;
            }

            // adding the trip cost check for resetting the errors after input

            if(!(/^\d+$/.test(this.form.travelerInfos[index].tripCost))){
                this.form.travelerInfos[index].tripCost=null;
            }

            if(index === 0){
                this.showPrimaryValidationForTripCost = false;
            }
            if(index > 0){
                this.showSecondaryValidationForTripCost = false;
            }
            this.showMobileError=false;
        },
        resetForm: function(e){

            this.form.startDate='';
            this.form.endDate='';

            this.form.travelerInfos= [
                {
                    age: null,
                    tripCost: null,
                    travelerType:''
                }
            ];
            this.travelersOpened=false;
            this.formSending=false;
            this.previousLoading=false;
            this.showMobileError=false;
            this.showPrimaryValidation=false;
            this.$v.$reset();
            this.$emit('resubmit');
            e.preventDefault();
        },
        addInputFocusOutline: function(){
            //Manually add focus for trip cxl partial border inputs
            if(document.getElementsByClassName('input-check')[0]){
                Array.prototype.forEach.call(document.getElementsByClassName('input-check'),(x,i)=>{

                    const index = Math.floor(i/2);
                    const partialBodyClass = document.getElementsByClassName('partial-border-split-half')[index];

                    x.addEventListener('focus',()=>{
                        partialBodyClass.classList.add('multiselect-focus');
                        partialBodyClass.style.padding = '5px 0';


                    });
                    x.addEventListener('blur',()=>{
                        partialBodyClass.classList.remove('multiselect-focus');
                        partialBodyClass.removeAttribute('style');

                    });
                });
            }
        }
    }
};
